module.exports = __webpack_public_path__ + "static/media/repuestosx2.950575e0.jpg";